import { RulesConfig } from "../model/languagetool/types"

export type Mode = "SpellCheck" | "Paraphrase"

export interface Segment {
    segmentType: Mode
    uuid: string
    offset: number
    length: number
}

export type SizeChange = {
    position: number
    difference: number
}

export enum Variants {
    General= "variant_general",
    Valencianes = "variant_valencia",
    Balears = "variant_balear"
}

export type ConfigProps = {
    characterLimit: number
    maxSuggestions: number,
    maxSpellcheckSuggestions: number,
    maxSuggestionsMobile: number,
    defaults: DefaultRules
    groups: OptionGroupProps[]
}

type DefaultRules = {
    [key: string]: Rules
}

export type OptionGroupProps = {
    title?: string
    summary: string
    options: OptionProps[]
    variant?: Variants
}

export type OptionProps = OptionCheckbox | OptionRadio

type OptionCheckbox = OptionBase & { type: "checkbox"}
type OptionRadio = OptionBase & { type: "radio" }

type OptionBase =  {
    title: string
    values: ValueProps[]
    id: string
    link?: string
    hide?: boolean
}

export type ValueProps = {
    id: string
    title: string
    default?: boolean,
    invertRules?: boolean,
    rules?: Rules
    link?: string
    hide?: boolean
}

type Rules = Partial<RulesConfig>